import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';
import { pushViewCart } from '@theme/data-layer-helper';

class CartDrawerComponent extends DialogComponent {
  /** @type {MutationObserver | null} */
  #dialogObserver = null;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    // Set up observer after the dialog exists
    this.#setupDialogObserver();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    if (this.#dialogObserver) {
      this.#dialogObserver.disconnect();
      this.#dialogObserver = null;
    }
  }

  /**
   * Observe the dialog element for changes in its open state.
   * If it closes without a user-initiated action, re-open it.
   */
  #setupDialogObserver() {
    const dialog = this.querySelector('dialog');

    if (!(dialog instanceof HTMLDialogElement)) return;

    if (this.#dialogObserver) {
      this.#dialogObserver.disconnect();
    }

    this.#dialogObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          const isOpen = dialog.open;
        }
      }
    });

    this.#dialogObserver.observe(dialog, {
      attributes: true,
      attributeFilter: ['open'],
    });
  }

  /**
   * Open the drawer on cart add when auto-open is enabled.
   */
  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  /**
   * Public open method (used by your templates via on:click="/open").
   */
  open() {
    this.showDialog();

    // Push view_cart event to dataLayer
    pushViewCart();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  /**
   * Public close method (used by your close button / overlay).
   * Marks the close as user-initiated so the observer doesn't auto-reopen.
   */
  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
